var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlexTokenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.001,
    cy: 12.005,
    r: 12.001,
    fill: "url(#alex-token-logo_svg__paint0_radial_782_2166)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.946 18.117a9.416 9.416 0 01-.792-1.056l5.056-5.056L4.154 6.95c.24-.37.504-.723.792-1.056l6.112 6.111-6.112 6.112zM3.49 8.17c-.198.44-.361.894-.489 1.359l2.477 2.476L3 14.482c.128.465.291.919.49 1.358l3.835-3.835L3.489 8.17zm8.512 4.78L5.889 19.06c.333.289.686.553 1.056.792l5.056-5.056 5.055 5.056c.37-.239.723-.503 1.056-.792l-6.111-6.111zm3.835 7.568L12 16.683l-3.835 3.835c.44.198.894.362 1.359.49L12 18.53l2.477 2.476a9.32 9.32 0 001.36-.49v.001zm-3.835-9.456l6.111-6.11a9.351 9.351 0 00-1.056-.793l-5.055 5.056-5.056-5.056c-.37.24-.723.504-1.056.792l6.112 6.111zm8.51 4.778c.2-.44.363-.893.49-1.358l-2.476-2.477L21 9.53a9.255 9.255 0 00-.49-1.36l-3.834 3.836 3.835 3.835zm-5.72-3.835l5.056-5.055a9.408 9.408 0 00-.792-1.056l-6.11 6.111 6.112 6.112c.289-.334.553-.686.792-1.056l-5.058-5.056zm-2.79-4.676l3.835-3.835a9.26 9.26 0 00-1.359-.489L12 5.481 9.524 3.005a9.32 9.32 0 00-1.359.49L12 7.328z",
    fill: "url(#alex-token-logo_svg__paint1_radial_782_2166)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.946 18.117a9.416 9.416 0 01-.792-1.056l5.056-5.056L4.154 6.95c.24-.37.504-.723.792-1.056l6.112 6.111-6.112 6.112zM3.49 8.17c-.198.44-.361.894-.489 1.359l2.477 2.476L3 14.482c.128.465.291.919.49 1.358l3.835-3.835L3.489 8.17zm8.512 4.78L5.889 19.06c.333.289.686.553 1.056.792l5.056-5.056 5.055 5.056c.37-.239.723-.503 1.056-.792l-6.111-6.111zm3.835 7.568L12 16.683l-3.835 3.835c.44.198.894.362 1.359.49L12 18.53l2.477 2.476a9.32 9.32 0 001.36-.49v.001zm-3.835-9.456l6.111-6.11a9.351 9.351 0 00-1.056-.793l-5.055 5.056-5.056-5.056c-.37.24-.723.504-1.056.792l6.112 6.111zm8.51 4.778c.2-.44.363-.893.49-1.358l-2.476-2.477L21 9.53a9.255 9.255 0 00-.49-1.36l-3.834 3.836 3.835 3.835zm-5.72-3.835l5.056-5.055a9.408 9.408 0 00-.792-1.056l-6.11 6.111 6.112 6.112c.289-.334.553-.686.792-1.056l-5.058-5.056zm-2.79-4.676l3.835-3.835a9.26 9.26 0 00-1.359-.489L12 5.481 9.524 3.005a9.32 9.32 0 00-1.359.49L12 7.328z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "alex-token-logo_svg__paint0_radial_782_2166",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(35.3346 0 0 35.3306 26.117 24.057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02E1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0B54FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1152FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#204BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3B40FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5F31FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8E1EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A714FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "alex-token-logo_svg__paint1_radial_782_2166",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(26.501 0 0 26.4997 22.588 21.045)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02E1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0B54FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1152FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#204BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3B40FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5F31FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8E1EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A714FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlexTokenLogo);
export default __webpack_public_path__ + "static/media/alex-token-logo.8d8fab475d27adfdc355763b12dca47f.svg";
export { ForwardRef as ReactComponent };